import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { DefaultFormData } from '../../local-types';

interface FormBooleanProps extends DefaultFormData {
    value: number | boolean;
    reverse?: boolean;
}

const FormBoolean: React.FC<FormBooleanProps> = ({ value, reverse, id, name, label, hint, disabled, handleChange }) => {
    const classes = useStyles();

    // Convertir la valeur en booléen (1 -> true, 0 -> false)
    const checked = value === 1 || Boolean(value);

    return (
        <FormControl className={classes.formControl} margin="dense">
            <div className={classes.divControl}>
                {!reverse && <div className={classes.formLabel}>{label}</div>}
                <FormControlLabel
                    id={id}
                    name={name}
                    className={classes.formControlLabel}
                    control={
                        <Checkbox checked={checked} value={name || id} disabled={disabled} onChange={handleChange} />
                    }
                    label="" // Label vide car le label principal est externe
                />
                {reverse && <div className={classes.formLabel}>{label}</div>}
            </div>
            {hint && <div className={classes.hint}>{hint}</div>}
        </FormControl>
    );
};

//======================================//
//=============== Styles ===============//
//======================================//

const useStyles = makeStyles((theme) =>
    createStyles({
        formLabel: {
            fontSize: 12,
            color: theme.palette.primary.dark,
            fontWeight: 500,
        },
        formControl: {
            flexDirection: 'column',
        },
        formControlLabel: {
            marginLeft: 8,
        },
        divControl: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
        },
        hint: {
            fontSize: 12,
            color: theme.palette.text.secondary,
        },
    }),
);

export default FormBoolean;
